import React from 'react'
import {Styles} from "../../../../config/design/styles";
import FileManager from "../FileManager";
import {defaultVariables} from "../../../../config/index";
import {DialogContent, IconButton, Slide, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {Close} from "@mui/icons-material";
import {withStyles} from "@mui/styles";
import {translateKey} from "../../../../config/values";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class FileManagerDialog extends React.Component{
    state = {
        open: true
    };
    classes = this.props.classes;
    size = this.props.size ? this.props.size: 200;
    img_ = this.props.cover ? "" : this.size > 400 ? "_medium" : "_small";
    image_ = this.props.logo ? "_medium" : this.props.fourtotree ? this.size > 400 ? "_thumbnail" : "_small": this.img_ ;
    handleSetImage(data,preview = null){
        let res ={
            src:data.source,
            link:data.source_id ? `https://www.youtube.com/watch?v=${data.source_id}` : data.source,
            type:data.type,
            alt:data.alt,
            name:data.name,
            extension:data.extension,
            preview:!!preview ? preview :  data.preview,
            id:data.id,
            thumbSource: `${defaultVariables.uploads}/FileManager/${data.name}${this.image_}.${data.extension}`
        };
        if(this.props.setData !== undefined){
            this.props.setData(data)
        }else{
            this.props.setImage(res);

        }
    }
    handleSetPreview(data){
        this.props.setData(data)
    }
    handleClose = () => {
        this.setState({
            open:false
        });
        this.props.cancleOperation();

    };
    render(){
        let {open} = this.state;
        return(
            <>
                <Dialog fullWidth={true} maxWidth={"lg"} open={open} onClose={this.handleClose} TransitionComponent={Transition} >
                    <DialogTitle className={this.classes.appBarDialog}  onClose={this.handleClose}>
                        <Typography variant="h6" className={this.classes.titleDialog}>
                            {translateKey('chooseMedia')}
                        </Typography>
                        <IconButton
                            color="inherit"
                            onClick={this.handleClose}
                            aria-label="close"
                            className={this.classes.dialogClose}
                        >
                            <Close />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <FileManager
                            preview={this.props.preview}
                            modal
                            single={this.props.single}
                            onlyFile={this.props.onlyFile}
                            selection={this.props.selection === true}
                            fileType={this.props.fileType}
                            handleSetImage={this.handleSetImage.bind(this)}
                            handleSetPreview={this.handleSetPreview.bind(this)}
                            defined_width={this.props.defined_width}
                            defined_height={this.props.defined_height}
                        />
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}
export default  withStyles(Styles)(FileManagerDialog)